import React from "react";
import "./Policy.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

const ETIBaseCodes = () => {
  return (
    <>
      <Header />
      <div className="policy-container">
        <div className="policy-content">
          <h2>Código Base ETI</h2>
          <p className="paragrafo">
            O Código Base ETI (Ethical Trading Initiative)
            <br />
            <br />
            1. O emprego é escolhido livremente.
            <br />
            <br />
            1.1 Não há trabalho prisional, forçado, escravo ou involuntário.
            <br />
            <br />
            1.2 Os trabalhadores não são obrigados a realizar “depósitos” nem a
            entregar seus documentos de identidade ao empregador, e são livres
            para deixar o emprego mediante aviso prévio razoável.
            <br />
            <br />
            2. A liberdade de associação e o direito à negociação coletiva são
            respeitados.
            <br />
            <br />
            2.1 Todos os trabalhadores têm o direito de filiar-se ou constituir
            sindicatos de sua própria escolha e de negociar coletivamente.
            <br />
            <br />
            2.2 O empregador mantém uma postura aberta em relação às atividades
            sindicais e organizacionais.
            <br />
            <br />
            2.3 Os representantes dos trabalhadores não sofrem discriminação e
            têm acesso às suas funções representativas no local de trabalho.
            <br />
            <br />
            2.4 Quando o direito à liberdade de associação ou à negociação
            coletiva é restrito por lei, o empregador deve facilitar — e não
            impedir — o desenvolvimento de meios alternativos, independentes e
            livres, para associação e negociação.
            <br />
            <br />
            3. As condições de trabalho são seguras e higiênicas.
            <br />
            <br />
            3.1 Deve ser proporcionado um ambiente de trabalho seguro e
            higiênico, considerando os conhecimentos predominantes da indústria
            e quaisquer riscos específicos. Medidas adequadas devem ser tomadas
            para prevenir acidentes e danos à saúde decorrentes de, relacionados
            a, ou ocorridos durante o trabalho, minimizando, na medida do
            razoavelmente possível, as causas dos riscos inerentes ao ambiente
            laboral.
            <br />
            <br />
            3.2 Os trabalhadores devem receber treinamentos regulares e
            documentados sobre saúde e segurança, que devem ser repetidos para
            funcionários novos ou transferidos.
            <br />
            <br />
            3.3 Deve haver acesso a instalações sanitárias limpas, água potável
            e, quando apropriado, locais adequados para armazenamento de
            alimentos.
            <br />
            <br />
            3.4 As acomodações fornecidas pela empresa devem ser limpas, seguras
            e atender às necessidades básicas dos trabalhadores.
            <br />
            <br />
            3.5 A empresa que observa o código deve atribuir a responsabilidade
            pela saúde e segurança a um representante da alta administração.
            <br />
            <br />
            4. O trabalho infantil não deve ser usado.
            <br />
            <br />
            4.1 Não haverá nova contratação de trabalho infantil.
            <br />
            <br />
            4.2 As empresas devem desenvolver ou participar e contribuir para
            políticas e programas que prevêem a transição de qualquer criança
            que esteja realizando trabalho infantil para capacitá-la a
            frequentar e permanecer na educação de qualidade até não é mais uma
            criança; “infantil” e “trabalho infantil” definidos nos anexos.
            <br />
            <br />
            4.3 Crianças e jovens menores de 18 anos não devem ser empregados à
            noite ou em condições perigosas.
            <br />
            <br />
            4.4 Essas políticas e procedimentos devem estar em conformidade com
            as disposições da OIT relevante padrões.
            <br />
            <br />
            5. Salários dignos são pagos.
            <br />
            <br />
            5.1 Os salários e benefícios pagos por uma semana de trabalho padrão
            atendem, no mínimo, normas legais nacionais ou padrões de referência
            da indústria, o que for maior. Dentro qualquer evento, os salários
            devem sempre ser suficientes para atender às necessidades básicas e
            fornecer alguma renda discricionária.
            <br />
            <br />
            5.2 Todos os trabalhadores devem receber informações escritas e
            compreensíveis sobre suas condições de emprego em relação aos
            salários antes de entrarem emprego e sobre os detalhes de seus
            salários para o período de pagamento em causa cada vez que são
            pagos.
            <br />
            <br />
            5.3 Deduções de salários como medida disciplinar não serão
            permitidas nem quaisquer deduções de salários não previstas pela lei
            nacional sejam permitidas sem a autorização expressa do trabalhador
            em causa. Tudo disciplinar medidas devem ser registradas.
            <br />
            <br />
            6. As horas de trabalho não são excessivas.
            <br />
            <br />
            6.1 O horário de trabalho deve estar de acordo com as leis
            nacionais, acordos coletivos e disposições de 6.2 a 6.6 abaixo, o
            que proporcionar maior proteção para os trabalhadores.
            <br />
            <br />
            As subcláusulas 6.2 a 6.6 são baseadas em padrões internacionais de
            trabalho.
            <br />
            <br />
            6.2 O horário de trabalho, excluindo horas extras, será definido em
            contrato, e não exceder 48 horas por semana.
            <br />
            <br />
            6.3 Todas as horas extras serão voluntárias. As horas
            extraordinárias devem ser utilizadas com responsabilidade, tendo em
            conta tudo o seguinte: a extensão, frequência e horas trabalhadas
            por trabalhadores e a força de trabalho como um todo. Não deve ser
            usado para substituir regular emprego. As horas extraordinárias
            serão sempre compensadas a uma taxa de prémio, que é recomendado não
            ser inferior a 125% da taxa normal de pagamento.
            <br />
            <br />
            6.4 O total de horas trabalhadas em qualquer período de sete dias
            não deve exceder 60 horas, exceto quando coberto pela cláusula 6.5
            abaixo.
            <br />
            <br />
            6.5 As horas de trabalho podem exceder 60 horas em qualquer período
            de sete dias apenas em circunstâncias excepcionais, nas quais todas
            as condições a seguir sejam atendidas:
            <br />
            <br />
            <ul>
              <li>isso é permitido pela legislação nacional;</li>
              <li>
                isso é permitido por um acordo coletivo livremente negociado com
                uma organização de trabalhadores que represente uma parcela
                significativa da força de trabalho;
              </li>
              <li>
                são adotadas as devidas salvaguardas para proteger a saúde e a
                segurança dos trabalhadores; e
              </li>
              <li>
                o empregador pode demonstrar que se aplicam circunstâncias
                excepcionais, como picos inesperados de produção, acidentes ou
                emergências.
              </li>
            </ul>
            <br />
            6.6 Os trabalhadores devem ter pelo menos um dia de folga a cada
            período de sete dias ou, onde permitido pela legislação nacional,
            dois dias de folga a cada período de 14 dias. <br />
            <br />
            <ul>
              <li>
                As normas internacionais recomendam a redução progressiva da
                jornada normal de trabalho, quando apropriado, para 40 horas
                semanais, sem qualquer redução nos salários dos trabalhadores à
                medida que as horas são reduzido.
              </li>
            </ul>
            <br />
            1. Nenhuma discriminação é praticada
            <br />
            <br />
            7.1 Não há discriminação na contratação, remuneração, acesso a
            treinamento, promoção, rescisão ou aposentadoria com base na raça,
            casta, nacionalidade, religião, idade, deficiência, sexo, estado
            civil, orientação sexual, união filiação ou filiação política.
            <br />
            <br />
            8. O emprego regular é fornecido
            <br />
            <br />
            8.1 Na medida do possível, o trabalho executado deve ser baseado em
            vínculo empregatício reconhecido estabelecido pela legislação
            nacional e prática.
            <br />
            <br />
            8.2 Obrigações para com os funcionários sob leis e regulamentos
            trabalhistas ou previdenciários decorrentes da relação de trabalho
            regular não devem ser evitados por meio de o uso de contratação
            apenas de mão de obra, subcontratação ou trabalho em casa acordos,
            ou através de esquemas de aprendizagem onde não há intenção real
            para transmitir habilidades ou fornecer emprego regular, nem tais
            obrigações serão evitadas pelo uso excessivo de contratos de
            trabalho a termo certo.
            <br />
            <br />
            9. Nenhum tratamento severo ou desumano é permitido
            <br />
            <br />
            9.1 Abuso físico ou disciplina, ameaça de abuso físico, abuso sexual
            ou outros assédio e abuso verbal ou outras formas de intimidação
            serão proibidos.
            <br />
            <br />
            As disposições deste código constituem padrões mínimos e não
            máximos, e este código não deve ser usado para evitar que as
            empresas excedam esses padrões. Empresas candidatas espera-se que
            este código esteja em conformidade com a legislação nacional e
            outras leis aplicáveis ​​e, quando o disposições da lei e este
            Código de Base tratam do mesmo assunto, aplicar aquela disposição
            que oferece maior proteção.
            <br />
            <br />
            JTD TRANSPORTES
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ETIBaseCodes;
